<template>
    <div>
        <FormModal v-if="selectChannelsModal" @cancel="selectChannelsModal = false"
            @confirm="selectChannelsModal = false" :valid="selectedChannels.length > 0" title="Select MIDs"
            subtitle="MIDs avaliable from retailer" submitButtonText="Confirm">

            <EasyDataTable :headers="channelTable" :items="channels" :loading="loading"
                v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                :no-hover="true">
                <template #loading>
                    <div class="p-4 w-full flex justify-center">
                        <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                    </div>
                </template>
                <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                </template>
                <template #header-action="header">
                    <div class="w-full text-right">
                        {{ header.text }}
                    </div>
                </template>

                <template #item-type="channel">
                    <div class="flex justify-start items-center py-1 gap-1">
                        <div v-if="selectedChannels.filter((val) => val.id == channel.id).length > 0" >
                            <p>Selected</p>
                        </div>

                    </div>
                </template>
                <template #item-action="channel">
                    <div class="flex justify-end items-center py-1 gap-1">
                        <CustomButton v-if="selectedChannels.filter((val) => val.id == channel.id).length > 0" text="Deselect" small type="warning" />
                        <CustomButton v-else @click="selectedChannels.push(channel)" text="Add channel" small type="navigate" />
                    </div>
                </template>
            </EasyDataTable>

        </FormModal>
        <div class="grid grid-cols-5 w-full">


            <div class="col-span-2 p-2">
                <div class="">
                    <div class="border-b border-gray-300 h-4">
                    </div>
                    <p class="flex justify-center items-center h-8 -mt-4">
                        <span class="px-2 bg-white font-medium text-sm text-gray-700">Supplier information</span>
                    </p>
                </div>
                <CustomInput class="w-full mt-2" v-model="offerInformation.supplierId" type="text" placeholder="2345"
                    label="Supplier Id" />
                <div class="mt-4">
                    <div class="border-b border-gray-300 h-4">
                    </div>
                    <p class="flex justify-center items-center h-8 -mt-4">
                        <span class="px-2 bg-white font-medium text-sm text-gray-700">Offer type and mids</span>
                    </p>
                </div>

                <CustomSelect :pre-select="offerInformation.offerType" v-model="offerInformation.offerType" class="w-full mt-2" :options="offerType" label="Offer type" />
                
                <CustomInput v-if="offerInformation.offerType === 'CLICK_TO_ACTIVATE'" v-model="offerInformation.lengthOfTime" class="w-full mt-2" type="number" placeholder="14 days"
                label="activated for" />
                
                
                <CustomSelect :pre-select="offerInformation.matchAgainst" class="w-full mt-2" v-model="offerInformation.matchAgainst" :options="matchAgainst" label="Match against" />

                <div v-if="offerInformation.matchAgainst == 'SPECIFIC_CHANNELS'" class="mt-2">
                    <p class="mt-2 text-sm font-medium">Select relevant MIDs</p>
                    <CustomButton class="w-full" text="Select MIDS" type="default"
                        @click="selectChannelsModal = true" />
                </div>
                <div class="mt-4">
                    <div class="border-b border-gray-300 h-4">
                    </div>
                    <p class="flex justify-center items-center h-8 -mt-4">
                        <span class="px-2 bg-white font-medium text-sm text-gray-700">Display information</span>
                    </p>
                </div>
                <CustomInput v-model="offerInformation.country" class="w-full mt-2" type="text" placeholder="GB"
                    label="Country" />

                <CustomInput v-model="offerInformation.currency" class="w-full mt-2" type="text" placeholder="GBP"
                    label="Currency" />

                <CustomInput class="w-full mt-2" type="file" placeholder="Boogi" label="Logo" @change="uploadFile"
                    ref="fileInput" accept=".png" />

                <CustomInput v-model="offerInformation.offerName" class="w-full mt-2" type="text"
                    placeholder="Boogi Technologies Ltd" label="Offer name" />

                <CustomInput class="w-full mt-2" v-model="offerInformation.offerDescription" type="text" multiline
                    placeholder="Boogi" label="Description" />

                    <CustomInput class="w-full mt-2" v-model="offerInformation.link" type="text" 
                    placeholder="Boogi" label="Weblink" />

                <CustomButton class="mt-5 w-full mt-3" :disabled="!validForm" text="Save" type="action"
                    @click="submitOfferInformation" />

            </div>
            <div v-if="offerInformationData.offerName != ''" class="col-span-3 p-2 justify-center">
            <div class="bg-[#F5F2FB] px-3 py-4 rounded-lg bg-opacity-60 grid gap-2 overflow-x-auto">
                <div class="grid gap-2" v-if="offerInformationData.offerName != ''">
                    <div 
                        class="flex justify-start items-center px-1 py-1 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <img class="object-contain w-[50px] h-[50px] rounded-lg border border-gray-200 bg-white"
                            :src="offerInformationData.offerLogo" />
                        <div class="">
                            <p class="font-semibold text-lg">{{ offerInformationData.offerName }}</p>
                        </div>
                    </div>

                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Offer Data</p>

                        <div class="px-1 py-1 text-sm ">
                            <div class="flex justify-between">
                                <p>Supplier Id:</p>
                                <p>{{ offerInformationData.supplierId }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Offer Type:</p>
                                <p>{{ offerInformationData.offerType }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Country avaliable:</p>
                                <p>{{ offerInformationData.country }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Currency:</p>
                                <p>{{ offerInformationData.currency }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Description</p>
                        <p class="text-sm">{{ offerInformationData.offerDescription }}</p>
                    </div>
                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Where to shop:</p>
                        <EasyDataTable :headers="headersTable1" :items="displayChannels"
                            :loading="loading" v-model:server-options="serverOptions"
                            :server-items-length="serverItemsLength" :hide-footer="false" :no-hover="true"
                            class="overflow-x-auto"
                        >
                            <template #loading>
                                <div class="p-4 w-full flex justify-center">
                                    <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                </div>
                            </template>
                            <template #empty-message>
                                <div class="flex justify-center py-4">
                                    <div
                                        class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                        <p class="text-sm mr-2">No results</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <template #header-action="header">
                                <div class="w-full text-right">
                                    {{ header.text }}
                                </div>
                            </template>


                        </EasyDataTable>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import CustomSelect from "../inputs/CustomSelect.vue";
import FormModal from "@/components/modals/FormModal.vue";



export default {
    name: "retailer-mapping",
    components: {
        CustomInput,
        CustomButton,
        CustomSelect,
        FormModal
    },
    props: {
        offerInformationData: {
            type: Object
        },
        retailerData: {
            type: Object
        }
    },
    data() {
        return {
            offerInformation: {
                supplierId: this.offerInformationData.supplierId,
                offerLogo: this.offerInformationData.offerLogo,
                offerLogoFile: this.offerInformationData.offerLogoFile,
                offerDescription: this.offerInformationData.offerDescription,
                country: this.offerInformationData.country,
                currency: this.offerInformationData.currency,
                offerName: this.offerInformationData.offerName,
                offerType: this.offerInformationData.offerType,
                category: this.offerInformationData.category,
                lengthOfTime: this.offerInformationData.lengthOfTime,
                matchAgainst: this.offerInformationData.matchAgainst,
                channels: this.offerInformationData.channels,
                cashbackRules: this.offerInformationData.cashbackRules,
                link: this.offerInformationData.link

            },


            selectChannelsModal: false,
            serverOptions: undefined,
            serverItemsLength: undefined,

            selectedChannels: [],
            displayChannels:[],

            channelTable: [
                { text: "Name", value: "channelName" },
                { text: "Selected", value: "type" },
                { text: "Actions", value: "action" },

            ],
            trueOrFalse: [
                { id: true, text: "Yes" },
                { id: false, text: "No" },

            ],

            matchAgainst: [
                { "id": "ALL_CHANNELS", "text": "All transactions" },
                { "id": "SPECIFIC_CHANNELS", "text": "Specific MIDs" },

            ],

            offerType: [
                { "id": "ONLINE", "text": "Online offer" },
                { "id": "PAYMENT", "text": "Payment linked offer" },
                { "id": "CLICK_TO_ACTIVATE", "text": "Click to activate payment offers" }

            ],

            category: [
            { id: "HEALTH_BEAUTY", text: "Health & Beauty" },
            { id: "ELECTRONICS", text: "Electronics" },
            { id: "FASHION", text: "Fashion" },
            { id: "HOME", text: "Home" },
            { id: "LUXURY", text: "Luxury" },
            { id: "SPORTS", text: "Sports" },
            { id: "TRAVEL", text: "Travel" },
            { id: "DIGITAL", text: "Digital" },
            { id: "ACCESSORIES", text: "Accessories" },
            { id: "FOOD_DRINK", text: "Food & Drink" },
            { id: "SHOPPING", text: "Shopping" },
            { id: "WELLNESS", text: "Wellness" },
            { id: "ENTERTAINMENT", text: "Entertainment" },
            { id: "ESSENTIALS", text: "Essentials" }
            ],

            headersTable1: [
                { text: "Name", value: "channelName" },
                { text: "Website", value: "website" },
                { text: "Address", value: "address" },
                { text: "Postcode", value: "postcode" },

            ],

            channels: [

            ]

        }
    },

    created() {
        this.getChannels(0, 25)
        this.getDisplayChannels()
    },
    computed: {
        validForm() {
            return  this.offerInformation.supplierId != "" &&
                (this.offerInformation.offerLogoFile != undefined || this.offerInformation.offerLogo) && this.offerInformation.country != ""
                && this.offerInformation.currency != "" && (this.offerInformation.offerName != "" && this.offerInformation.offerName != null)
                && this.offerInformation.offerType != undefined && this.offerInformation.matchAgainst != "" && this.offerInformation.link != ""
        }
    },
    methods: {

        async getDisplayChannels(){
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/channels-by-id`, {
                    method: "POST",
                    body: JSON.stringify(this.offerInformation.channels),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.displayChannels = object
                    this.loading = false
                }

            } catch {
                return
            }
        },

        submitOfferInformation() {

            if (this.offerInformation.matchAgainst == 'ALL_CHANNELS') {
                this.getAllChannelIds()

            } else {
                this.offerInformation.channels = this.selectedChannels.map(val => val.id)
                this.$emit('formSubmit', this.offerInformation)
                this.getDisplayChannels()


            }

        },

        uploadFile: function () {
            // const file = event.target.files[0];
            this.offerInformation.offerLogoFile = event.target.files[0]
            if (this.offerInformation.offerLogoFile != undefined) {
                this.offerInformation.offerLogo = URL.createObjectURL(this.offerInformation.offerLogoFile)
            }
        },
        async getChannels(page, size) {
            this.loading = true
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer/${this.retailerData.id}/channel?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.channels = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch {
                return
            }
        },

    async getAllChannelIds() {
           try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer/${this.retailerData.id}/channel/ids`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.offerInformation.channels= object
                    this.$emit('formSubmit', this.offerInformation)
                    this.getDisplayChannels()


                }

            } catch {
                return
            }
        },
    },

}
</script>